module.exports = __webpack_public_path__ + "img/five.d3580e7d.png";